import type { CrmObject } from '@/types/crm';
import { getPropertyValue } from '@/types/crm';

/**
 * Normalizes a meeting's `ahoy_recurring_series_id` property into a stable
 * series key.
 *
 * The backend writes an empty string for non-recurring meetings; an absent
 * property resolves to `undefined` via `getPropertyValue`. Both — along with
 * whitespace-only values — normalize to `null`. A trimmed, non-empty value is
 * returned as the series key.
 *
 * Single source of truth for series-id parsing, shared by the meeting
 * summaries grouping (`meetingSeriesGrouping`) and the meeting-record series
 * hook (`useMeetingSeries`) so the two paths cannot drift apart.
 */
export function getMeetingSeriesId(meeting: CrmObject | null): string | null {
  const value = getPropertyValue<string>(
    meeting?.properties?.ahoy_recurring_series_id
  );
  const trimmed = typeof value === 'string' ? value.trim() : '';
  return trimmed.length > 0 ? trimmed : null;
}
